<!-- 新增市场拓展目标 -->
<template>
  <div class="content" v-loading.fullscreen.lock="fullscreenLoading">
    <!-- start of title -->
    <div class="title-box">
      <el-button type="default" size="small" @click="back">返回</el-button>
      <span>{{ textTitle }}</span>
    </div>
    <!-- end of title -->

    <el-form label-width="200px">
      <!-- start of 基本信息 -->
      <div class="back-color-fff form-box" >
        <span class="form-title">基本信息</span>
        <div class="form-item-box">
          <el-row>
            <el-col :span="12">
              <!-- 公司名称 -->
              <el-form-item label="公司名称" prop="tenantName">
                <span slot="label" style="color: red">*</span>
                <span slot="label">公司名称 </span>
                <el-select class="w240" size="small" filterable  v-model="form.tenantGuid" @change="changeTenant" placeholder="请选择">
                  <el-option
                  v-for="item in tenantList"
                  :key="item.sendTenantGuid"
                  :label="item.sendTenantName"
                  :value="item.sendTenantGuid"
                        
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <!-- 部门名称 -->
              <el-form-item label="部门名称" prop="abbreviation">
                <span slot="label" style="color: red"> </span>
                <span slot="label">部门名称 </span>
                <el-select class="w240" size="small" filterable clearable v-model="form.organisationGuid" placeholder="请选择" >
                  <el-option
                    v-for="item in departmentList"
                    :key="item.guid"
                    :label="item.organisationName"
                    :value="item.guid"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>

            <el-col :span="12">
              <!-- 目标产品 -->
              <el-form-item label="目标产品" prop="enterpriseCate">
                <span slot="label" style="color: red">*</span>
                <span slot="label">目标产品 </span>
                <el-select class="w240" size="small" filterable clearable v-model="form.goodsGuid" @change="changeGoods" @clear="clearGoods" placeholder="请选择">
                  <el-option
                    v-for="item in goodsList"
                    :key="item.guid"
                    :label="item.goodsName"
                    :value="item.guid"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>

            <el-col :span="12">
              <!-- 年份 -->
              <el-form-item label="年份" prop="year">
                <span slot="label" style="color: red">*</span>
                <span slot="label">年份</span>
                <el-date-picker
                  class="w240"
                  v-model="form.year"
                  format="yyyy年"
                  type="year"
                  value-format="yyyy"
                  placeholder="选择年">
                </el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
          <div v-if="showGoods" class="goodsInfo">
            <p>
              产品规格：{{ form.goodsSpec ||"-"}}
            </p>
            <p>
              生产厂家：{{ form.producer||"-" }}
            </p>
          </div>
        </div>
      </div>
      <!-- end of 基础信息 -->
      <!-- start of 制定目标 -->
      <div class="back-color-fff form-box" style="height: 380px;">
        <span class="form-title">制定目标</span>
        <div class="form-item-box">
          <el-row>
            <!-- 拓展目标金额 -->
            <el-col :span="12">
              <el-form-item label="1月拓展目标金额（元）" prop="janExpandTarget">
                <span slot="label" style="color: red">*</span>
                <span slot="label">1月拓展目标金额（元） </span>
                <el-input
                  class="w240"
                  size="small"
                  placeholder="请输入"
                  maxlength="13"
                  @focus="amount.janExpandTarget=changeAmount(amount.janExpandTarget,true)"
                  @input="onInput('janExpandTarget')"
                  v-model.trim="amount.janExpandTarget"
                  @blur="amount.janExpandTarget=checkNum(amount.janExpandTarget)"
                >
                <!-- @input="amount.janExpandTarget=amount.janExpandTarget.replace(/^\D*(\d{1,10}(?:\.\d{0,2})?).*$/g, '$1')" -->
                </el-input>
              </el-form-item>
            </el-col>
            <!-- 2月拓展目标金额（元） -->
            <el-col :span="12">
              <el-form-item label="2月拓展目标金额（元）" prop="febExpandTarget">
                <span slot="label" style="color: red">*</span>
                <span slot="label">2月拓展目标金额（元） </span>
                <el-input
                  class="w240"
                  size="small"
                  placeholder="请输入"
                  maxlength="13"
                  @focus="amount.febExpandTarget=changeAmount(amount.febExpandTarget,true)"
                  @input="onInput('febExpandTarget')"
                  v-model.trim="amount.febExpandTarget"
                  @blur="amount.febExpandTarget=checkNum(amount.febExpandTarget)"
                  
                >
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <!-- 拓展目标金额 -->
            <el-col :span="12">
              <el-form-item label="3月拓展目标金额（元）" prop="marExpandTarget">
                <span slot="label" style="color: red">*</span>
                <span slot="label">3月拓展目标金额（元） </span>
                <el-input
                  class="w240"
                  size="small"
                  placeholder="请输入"
                  maxlength="13"
                  @focus="amount.marExpandTarget=changeAmount(amount.marExpandTarget,true)"
                  @input="onInput('marExpandTarget')"                  v-model.trim="amount.marExpandTarget"
                  @blur="amount.marExpandTarget=checkNum(amount.marExpandTarget)"
                >
                </el-input>
              </el-form-item>
            </el-col>
            <!-- 4月拓展目标金额（元） -->
            <el-col :span="12">
              <el-form-item label="4月拓展目标金额（元）" prop="aprExpandTarget">
                <span slot="label" style="color: red">*</span>
                <span slot="label">4月拓展目标金额（元） </span>
                <el-input
                  class="w240"
                  size="small"
                  placeholder="请输入"
                  maxlength="13"
                  @focus="amount.aprExpandTarget=changeAmount(amount.aprExpandTarget,true)"
                  @input="onInput('aprExpandTarget')"                   v-model.trim="amount.aprExpandTarget"
                  @blur="amount.aprExpandTarget=checkNum(amount.aprExpandTarget)"
                >
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <!-- 拓展目标金额 -->
            <el-col :span="12">
              <el-form-item label="5月拓展目标金额（元）" prop="mayExpandTarget">
                <span slot="label" style="color: red">*</span>
                <span slot="label">5月拓展目标金额（元） </span>
                <el-input
                  class="w240"
                  size="small"
                  placeholder="请输入"
                  maxlength="13"
                  @focus="amount.mayExpandTarget=changeAmount(amount.mayExpandTarget,true)"
                  @input="onInput('mayExpandTarget')"                   v-model.trim="amount.mayExpandTarget"
                  @blur="amount.mayExpandTarget=checkNum(amount.mayExpandTarget)"
                >
                </el-input>
              </el-form-item>
            </el-col>
            <!-- 拓展目标金额（元） -->
            <el-col :span="12">
              <el-form-item label="6月拓展目标金额（元）" prop="junExpandTarget">
                <span slot="label" style="color: red">*</span> 
                <span slot="label">6月拓展目标金额（元） </span>
                <el-input
                  class="w240"
                  size="small"
                  placeholder="请输入"
                  maxlength="13"
                  @focus="amount.junExpandTarget=changeAmount(amount.junExpandTarget,true)"
                  @input="onInput('junExpandTarget')"                      v-model.trim="amount.junExpandTarget"
                  @blur="amount.junExpandTarget=checkNum(amount.junExpandTarget)"
                >
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <!-- 拓展目标金额 -->
            <el-col :span="12">
              <el-form-item label="7月拓展目标金额（元）" prop="julExpandTarget">
                <span slot="label" style="color: red">*</span>
                <span slot="label">7月拓展目标金额（元） </span>
                <el-input
                  class="w240"
                  size="small"
                  placeholder="请输入"
                  maxlength="13"
                  @focus="amount.julExpandTarget=changeAmount(amount.julExpandTarget,true)"
                  @input="onInput('julExpandTarget')"                     v-model.trim="amount.julExpandTarget"
                  @blur="amount.julExpandTarget=checkNum(amount.julExpandTarget)"
                >
                </el-input>
              </el-form-item>
            </el-col>
            <!-- 拓展目标金额（元） -->
            <el-col :span="12">
              <el-form-item label="8月拓展目标金额（元）" prop="augExpandTarget">
                <span slot="label" style="color: red">*</span>
                <span slot="label">8月拓展目标金额（元） </span>
                <el-input
                  class="w240"
                  size="small"
                  placeholder="请输入"
                  maxlength="13"
                  @focus="amount.augExpandTarget=changeAmount(amount.augExpandTarget,true)"
                  @input="onInput('augExpandTarget')"                     v-model.trim="amount.augExpandTarget"
                  @blur="amount.augExpandTarget=checkNum(amount.augExpandTarget)"
                >
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <!-- 拓展目标金额 -->
            <el-col :span="12">
              <el-form-item label="9月拓展目标金额（元）" prop="septExpandTarget">
                <span slot="label" style="color: red">*</span>
                <span slot="label">9月拓展目标金额（元） </span>
                <el-input
                  class="w240"
                  size="small"
                  placeholder="请输入"
                  maxlength="13"
                  @focus="amount.septExpandTarget=changeAmount(amount.septExpandTarget,true)"
                  @input="onInput('septExpandTarget')"                   v-model.trim="amount.septExpandTarget"
                  @blur="amount.septExpandTarget=checkNum(amount.septExpandTarget)"
                >
                </el-input>
              </el-form-item>
            </el-col>
            <!-- 10月拓展目标金额（元） -->
            <el-col :span="12">
              <el-form-item label="10月拓展目标金额（元）" prop="octExpandTarget">
                <span slot="label" style="color: red">*</span>
                <span slot="label">10月拓展目标金额（元） </span>
                <el-input
                  class="w240"
                  size="small"
                  placeholder="请输入"
                  maxlength="13"
                  @focus="amount.octExpandTarget=changeAmount(amount.octExpandTarget,true)"
                  @input="onInput('octExpandTarget')"                   v-model.trim="amount.octExpandTarget"
                  @blur="amount.octExpandTarget=checkNum(amount.octExpandTarget)"
                >
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <!-- 拓展目标金额 -->
            <el-col :span="12">
              <el-form-item label="11月拓展目标金额（元）" prop="novExpandTarget">
                <span slot="label" style="color: red">*</span>
                <span slot="label">11月拓展目标金额（元） </span>
                <el-input
                  class="w240"
                  size="small"
                  placeholder="请输入"
                  maxlength="13"
                  @focus="amount.novExpandTarget=changeAmount(amount.novExpandTarget,true)"
                  @input="onInput('novExpandTarget')"                  v-model.trim="amount.novExpandTarget"
                  @blur="amount.novExpandTarget=checkNum(amount.novExpandTarget)"
                >
                </el-input>
              </el-form-item>
            </el-col>
            <!-- 拓展目标金额（元） -->
            <el-col :span="12">
              <el-form-item label="12月拓展目标金额（元）" prop="decExpandTarget">
                <span slot="label" style="color: red">*</span>
                <span slot="label">12月拓展目标金额（元） </span>
                <el-input
                  class="w240"
                  size="small"
                  placeholder="请输入"
                  maxlength="13"
                  @focus="amount.decExpandTarget=changeAmount(amount.decExpandTarget,true)"
                  @input="onInput('decExpandTarget')"                   v-model.trim="amount.decExpandTarget"
                  @blur="amount.decExpandTarget=checkNum(amount.decExpandTarget)"
                >
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <!-- 年底拓展目标金额 -->
            <el-col :span="12">
              <el-form-item label="年底拓展目标金额合计（元）" prop="contacts">
                 
                <span slot="label">年底拓展目标金额合计（元） </span>
                <el-input
                  class="w240"
                  size="small"
                  v-model="expandTargetTotalInfo"
                  :disabled="true"
                  placeholder="系统自动合计，不可编辑"
                  
                >
               
                </el-input>
              </el-form-item>
            </el-col>
            <!--合计大写（元） -->
            <el-col :span="12">
              <el-form-item label="合计大写" prop="abbreviation">
                 
                <span slot="label">合计大写 </span>
                {{ form.expandTargetTotal | smallToBig }}
              </el-form-item>
            </el-col>
          </el-row>
          
        </div>
        
      </div>
      <!-- end of 制定目标 -->
      <div class="operte-btns">
          <div class="btn cancel" @click="back">取消</div>
          <div  class="btn submit" @click="addReqVersion">提交</div>
        </div>
      
     
      
    </el-form>
    
    
  </div>
</template>

<script>
import dialogMap from '../../components/dialogMap';
import InvoiceMessage from '../../components/invoiceMessage.vue'
// import { route } from '@/api/apiRoute';
// import store from '@/store';
import { changeNum } from '@/api/portrait.js'
export default {
  components: {
    dialogMap,
    InvoiceMessage
  },
  data() {
    return {
      textTitle: '新增市场拓展目标',
      totalAmount:'',//总金额
      totalAmountText:'',//总金额
      showGoods:false,
      fullscreenLoading:false,
      guid:'',
      // goodsSpec:'',//规格
      // producer:'',//厂家
      tenantList: [],// 应用公司列表
      departmentList: [],// 应用部门列表
      goodsList:[],//产品列表
      form:{
        guid:'',// 系统唯一标识
        tenantGuid:'',//企业GUID
        tenantName:'',//企业名称
        organisationGuid:'',//组织GUID
        goodsGuid:'',//商品GUID，关联mf_goods的guid
        goodsName:'',//商品名称
        goodsSpec:'',//商品规格
        producer:'',//生产厂商
        year:'',//年份
        janExpandTarget:'',//一月拓展目标金额
        febExpandTarget	:'',//二月拓展目标金额
        marExpandTarget	:'',//三月拓展目标金额
        aprExpandTarget	:'',//四月拓展目标金额
        mayExpandTarget	:'',//五月拓展目标金额
        junExpandTarget	:'',//六月拓展目标金额
        julExpandTarget	:'',//七月拓展目标金额
        augExpandTarget:'',//八月拓展目标金额
        septExpandTarget:'',//九月拓展目标金额
        octExpandTarget	:'',//十月拓展目标金额
        novExpandTarget:'',//十一月拓展目标金额
        decExpandTarget	:'',//十二月拓展目标金额
        expandTargetTotal	:'',//总计
      },
      amount:{
        janExpandTarget:'',//一月拓展目标金额
        febExpandTarget	:'',//二月拓展目标金额
        marExpandTarget	:'',//三月拓展目标金额
        aprExpandTarget	:'',//四月拓展目标金额
        mayExpandTarget	:'',//五月拓展目标金额
        junExpandTarget	:'',//六月拓展目标金额
        julExpandTarget	:'',//七月拓展目标金额
        augExpandTarget:'',//八月拓展目标金额
        septExpandTarget:'',//九月拓展目标金额
        octExpandTarget	:'',//十月拓展目标金额
        novExpandTarget:'',//十一月拓展目标金额
        decExpandTarget	:'',//十二月拓展目标金额
      },
      expandTargetTotalInfo:'',//千分位的总计
      
    };
  },
  watch:{
    
  },
 
  created() {
    
    this.getTenantList()//获取公司列表
    if (this.$route.query.guid) {
      this.textTitle='编辑市场拓展目标'
      this.guid = this.$route.query.guid;
      this.getDataDetail(this.guid);
    }
    
  },
  
  methods: {
    setNum(val) {
      let num=changeNum(Number(val),2)
      // if (num!=0) {
      //   return num
      // } else return ''
      return num
    },
     
    changeTenant(val){
      if (val) {
        this.tenantList.forEach((i) => {
          if (i.sendTenantGuid === val) {
            this.form.tenantName = i.sendTenantName;
          }
        })
      }
      this.form.organisationGuid=''
      this.form.goodsGuid=''
      this.form.goodsName=''
      this.form.goodsSpec=''
      this.form.producer=''
      this.showGoods=false
      this.getDepartmentList(val)
      this.getGoodsList(val)
      
    },
    changeGoods(val){
      
      if (val) {
        this.showGoods=true
        this.goodsList.forEach((i) => {
          if (i.guid === val) {
            this.form.goodsSpec = i.goodsSpec;//规格
            this.form.producer = i.producer;//厂家
            this.form.goodsName = i.goodsName;
          }
        })
      }
    },
    clearGoods(){
      this.form.goodsSpec=''
      this.form.producer=''
      this.form.goodsGuid=''
      this.form.goodsName=''
      this.showGoods=false
    },
    back() {
      let that = this;
      that.$router.push({ path: '/marketingTargetList', query: { tenantGuid: that.$route.query.tenantGuid } });
    },
    // 获取应用公司
    getTenantList() {
        let that = this;
        let query = {
          'pageIndex':1,
          'pageSize':-1,
          'bizState':'Y',
          'enterpriseCates':this.$getValueListByKey('上游客户分类')
        };
        that.api
        .postJson(`/${serverConfig.msCustomerService}/tenant/data/get-tenant-operation`,query)
          .then((res) => {
            if (res.data.code === serverConfig.REQUIRE_SUCCESS_CODE) {
              that.tenantList = res.data.data.records;
            } else {
              that.$message.error(res.data.msg);
            }
          });
    },
    // 获取部门
    getDepartmentList(val) {
        let that = this;
        let query = {
          pageIndex:1,
          pageSize:-1,
          tenantGuid: val,
        };
        that.api
          .postJson(
            `/${serverConfig.msPersonnelService}/organisation/data/get` ,
            query
          )
          .then((res) => {
            if (res.data.code === serverConfig.REQUIRE_SUCCESS_CODE) {
              that.departmentList = res.data.data.records;
            } else {
              that.$message.error(res.data.msg);
            }
          });
    },
    // 获取产品
    getGoodsList(val,flg) {
        let that = this;
        let query = {
          tenantGuid: val,
          isCompetitor: "N",
          selectType: "1"
        };
        that.api
          .postJson(
            `/${serverConfig.msProductService}/goods/get-all-goods` ,
            query
          )
          .then((res) => {
            if (res.data.code === serverConfig.REQUIRE_SUCCESS_CODE) {
              that.goodsList = res.data.data;
              // if(flg) {
              //   that.changeGoods(that.form.goodsGuid)
                
              // }
            } else {
              that.$message.error(res.data.msg);
            }
          });
    },
    // 获取详情
    getDataDetail(guid) {
        let that = this;
        that.form = [];
        that.fullscreenLoading=true
        that.api
          .get(
            `/${serverConfig.msSalesPerformService}/marketExpandTarget/detail/${guid}`
          )
          .then(async (res) => {
            
             if (res.data.code === serverConfig.REQUIRE_SUCCESS_CODE) {
              let data=res.data.data
              that.form = res.data.data;
              this.expandTargetTotalInfo=this.setNum(data.expandTargetTotal),
              this.showGoods=true
              for(let key in this.amount){
                this.amount[key]=this.setNum(data[key])
              }
              
              await this.getGoodsList(that.form.tenantGuid)
              this.getDepartmentList(that.form.tenantGuid)
              that.fullscreenLoading=false
            } else {
              that.fullscreenLoading=false
              that.$message.error(res.data.msg);
            }
          });
    },
    checkNum(val){
      if(val==0 ){
        val='0.00'
      }
      val=this.changeAmount(val)
      if(val.length>13 || isNaN(val)){
        this.$message.error('请输入正确金额');
        return
      }
      let num=this.setNum(parseFloat(val));
      
      this.sum()
      return num
      
    },
    onInput(val) { 
      // 使用正则表达式验证输入 
      const regex = /^(\d{1,10}(\.\d{0,2})?)?$/;
       if (!regex.test(this.amount[val])) {
         this.amount[val] = this.amount[val].slice(0, -1); // 删除最后一个非法字符
    } },
    changeAmount(val,flg){
      let num='0.00'
      if(flg)num=''
      
      if(val){
        if (isNaN(val)) {
          
          num=parseFloat(val.replace(/,/g, "")).toFixed(2)
        } else {
          num=parseFloat(val.toString().replace(/,/g, "")).toFixed(2)
        }
      }
      
      return num
    },
    // 计算总计
    sum() {
      var that = this;
      if (!this.form.tenantGuid) {
        this.$message.error('请选择公司名称');
        return;
      }
      if (!this.form.goodsGuid) {
        this.$message.error('请选择目标产品');
        return;
      }
      if (!this.form.year) {
        this.$message.error('请选择年份');
        return;
      }
      // for(let key in this.amount){
      //   try{
      //       if(!this.amount[key]){
      //         throw new Error('目标金额不能为空');
      //       }
      //     } catch (e) {
      //       this.$message.error(e.message);
      //       return;
      //     }
      // }
      
      let amount1=JSON.parse(JSON.stringify(this.amount))
      for(let key in amount1){
        
        amount1[key]=this.changeAmount(this.amount[key])
      }
      let req={
        tenantGuid:this.form.tenantGuid,
        tenantName:this.form.tenantName,
        goodsGuid:this.form.goodsGuid,
        year:this.form.year,
        ...amount1
        
      }
       
      that.api.postJson(`/${serverConfig.msSalesPerformService}/marketExpandTarget/total-amount-calc`, req).then((res) => {
        that.fullscreenLoading = false;
        if (res.data.code === serverConfig.REQUIRE_SUCCESS_CODE) {
          that.form.expandTargetTotal=res.data.data
          that.expandTargetTotalInfo=that.setNum(parseFloat(res.data.data));
        } else {
          that.$message.error(res.data.msg);
        }
      });
    },
    // 添加
    addReqVersion() {
      var that = this;
      // 基础必填
      if (!this.form.tenantGuid) {
        this.$message.error('请选择公司名称');
        return;
      }
      if (!this.form.goodsGuid) {
        this.$message.error('请选择目标产品');
        return;
      }
      if (!this.form.year) {
        this.$message.error('请选择年份');
        return;
      }
      for(let key in this.amount){
        try{
            if(!this.amount[key]){
              throw new Error('目标金额不能为空');
            }
          } catch (e) {
            this.$message.error(e.message);
            return;
          }
      }
      let amount1=JSON.parse(JSON.stringify(this.amount))
      for(let key in amount1){
        amount1[key]=this.changeAmount(this.amount[key])
      }
      let req={
        guid:that.guid||"",
        tenantGuid:this.form.tenantGuid,
        tenantName:this.form.tenantName,
        organisationGuid:this.form.organisationGuid||'',
        goodsGuid:this.form.goodsGuid,
        goodsName:this.form.goodsName,
        year:this.form.year,
        ...amount1
        
      }
      
      let reqUrl=`/${serverConfig.msSalesPerformService}/marketExpandTarget/add`
      let methods='postJson'
      let message='新增成功'
      if(that.guid){
        reqUrl=`/${serverConfig.msSalesPerformService}/marketExpandTarget/update`
        methods='put'
        message='修改成功'
      }
     
      that.api[methods](reqUrl,req).then((res) => {
        that.fullscreenLoading = false;
        if (res.data.code === serverConfig.REQUIRE_SUCCESS_CODE) {
          that.$message.success(message);
          that.back(); // 返回上一页
        } else {
          that.$message.error(res.data.msg);
        }
      });
    },
    
   
   

  },
  
};

</script>
<style lang="less" scoped>
.goodsInfo{
  
  width: 233px;
  height: 65px;
  line-height: 20px;
  border: 1px solid #DCDFE6;
  border-radius: 2px;
  margin-left: 200px;
  padding-top: 10px;
  padding-left: 5px;
  p{
    margin:0
  }
}
.account-radio-class{
  width: 640px;
  display: flex;
  justify-content: flex-start;
  flex-wrap: nowrap;
  align-items: center;
}
.content {
  padding: 0px;
  margin: 0px;
  min-width:800px;
  
  .title-box {
    border-top: 1px solid #e5e5e5;
    background-color: #ffffff;
    padding: 8px 0px;
    position: relative;
    button {
      font-size: 12px;
      color: #212121;
      letter-spacing: 0;
      width: 60px;
      height: 26px;
      padding: 0px;
      border: 1px solid rgba(217, 217, 217, 1);
      border-radius: 2px;
      position: absolute;
      left: 16px;
      top: 6px;
    }
    span {
      text-align: center;
      font-size: 16px;
      font-weight: 400;
    }
  }
  .form-box {
    margin-top: 4px;
    text-align: left;
    .form-title {
      height: 40px;
      line-height: 40px;
      font-size: 16px;
      margin-left: 16px;
    }
    .form-item-box {
      width: 90%;
      margin: 0 auto;
      padding-bottom: 15px;
    }
    // .el-col-12 {
    //   height: 50px;
    // }
    .el-form-item {
      margin-bottom: 0px;
    }
    .el-input,
    .el-select {
      width: 314px;
    }
    .pickerDate{
      width: 300px;
    }
    .el-table{
      margin: 0 60px;
    }
    .el-table--border{
      border-bottom:1px solid #EBEEF5
    }
    .map-a-sty {
  width: 90px;
  height: 34px;
  line-height: 34px;
  color: #4fa1a4;
  padding: 0 5px;
  background: #ffffff;
  border-radius: 2px;
  border: 1px solid #4fa1a4;
  text-align: center;
  cursor: pointer;
  box-sizing: border-box;
}
    .age-are-box {
      display: flex;
      align-items: center;
      .el-input {
        width: 142px;
      }
      span {
        margin: 0px 8px;
      }
    }
    .bottom-btn-box {
      padding: 18px 0px;
      text-align: center;
      border-top: 1px solid #e5e5e5;
    }
  }

  /deep/ .el-form-item__error {
    padding-top: 0px;
  }
  .el-button--primary {
    color: #ffffff;
  }

  .file-list-box {
    position: relative;
    display: flex;
    // justify-content: space-between;
    align-items: flex-end;
    margin-bottom: 32px;
    .upload-file-box {
      max-width: calc(100% - 132px - 16px);
    }
    .btn-box {
      position: absolute;
      width: 180px;
      margin-left: 16px;
      height: 32px;
      left:430px
    }
  }
}
.confirmState{
  background-color: #ccc;
}
/deep/ .el-upload__tip {
  line-height: 1;
  margin-top: 8px;
  text-align: start;
}
/deep/ .el-upload-list__item {
  // width
  max-width: 422px;
}
.sub-title {
  line-height: 28px;
  width: 100%;
  display: flex;
  justify-content: space-between;
}
.sub-operate-add {
  color: #4fa1a4;
  margin-left: 14px;
  cursor: pointer;
}
.sub-operate-add2 {
  position: absolute;
  right: 0px;
  top: -35px;
}
.account-class{
  display: flex;
}
.acountMountClass{
  display: flex;
  flex-direction: column;
  margin-top: 13px;
}
.content-main-box{
  height: 100%;
  max-height: 300px;
  
}
.import-btn-tips {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: baseline;
}
.import-step-tip{
  p{
    line-height: 1.5;
  }
}
.import-tip{
  p{
    text-align: start;
  }
}
.operte-btns {
    background: #fff;
    margin-top: 2px;
    display: flex;
    justify-content: center;
    padding: 25px 0;
  }
  
  .operte-btns .btn {
    padding: 5px 18px;
    border: 1px solid rgba(217, 217, 217, 1);
    border-radius: 2px;
    cursor: pointer;
    margin-right: 10px;
  }
  
  .operte-btns .btn.save {
    border: 1px solid #4FA1A4;
    color: #4FA1A4;
    cursor: pointer;
  }
  
  .operte-btns .btn.submit {
    border: 1px solid #4FA1A4;
    background: #4FA1A4;
    color: #fff;
    cursor: pointer;
  }
</style>
